import React, { useState, useEffect } from "react";
import "../productList/productList.css";
import { FiEdit } from "react-icons/all";
import CreateResaurants from "./createRes";
import ListResaurants from "./listofRest";
import { FStorage, firebase_Db } from "../../config/firebaseConfig";

const DBName = "Restaurants";

function Restaurants() {
  const [openCreateComponent, setOpenCreateComponent] = useState(false);
  const [Arestaurants, setResaurants] = useState([]);

  useEffect(() => {
    const fetchrestaurants = async () => {
      const RestaurantCollection = await firebase_Db
        .collection(DBName)
        .orderBy("createdAt", "asc")
        .get();

      setResaurants(
        RestaurantCollection.docs.map((doc) => {
          return {
            data: doc.data(),
            id: doc.id,
          };
        })
      );
    };
    return fetchrestaurants();
  }, []);


  return (
    <div className="content productContent">
      <div className="bar">
        <button
          className="products-btn"
          onClick={() => setOpenCreateComponent(false)}
        >
          Restaurants
        </button>
        <button
          className="products-btn"
          onClick={() => setOpenCreateComponent(true)}
        >
          <FiEdit />
          create
        </button>{" "}
      </div>
      <div className="divider"> </div>{" "}
      {openCreateComponent ? (
        <CreateResaurants
          btnName="Create"
          titleName="Create new Product"
          submitType="Create"
          restaurantData=""
        />
      ) : (
        Arestaurants.map((restaut) => {
          return <ListResaurants restData={restaut} key={restaut.id} />;
        })
      )}{" "}
    </div>
  );
}

export default Restaurants;
